var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneral2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FFCF00;}\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.37,42.24H4.94c-2.11,0-3.82-1.71-3.82-3.82V12.27c0-2.11,1.71-3.82,3.82-3.82h36.43 c2.11,0,3.82,1.71,3.82,3.82v26.16C45.18,40.54,43.47,42.24,41.37,42.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.01,42.24c0,2.08,0.66,3.77,1.32,4.93c0.46,0.81-0.15,1.82-1.08,1.82h-4.1h-4.1 c-0.94,0-1.54-1.01-1.08-1.82c0.66-1.17,1.32-2.86,1.32-4.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M41.37,42.24H4.94c-2.11,0-3.82-1.71-3.82-3.82V12.27c0-2.11,1.71-3.82,3.82-3.82h36.43 c2.11,0,3.82,1.71,3.82,3.82v26.16C45.18,40.54,43.47,42.24,41.37,42.24z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.15,
    cy: 37.59,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M27.01,42.24c0,2.08,0.66,3.77,1.32,4.93c0.46,0.81-0.15,1.82-1.08,1.82h-4.1h-4.1 c-0.94,0-1.54-1.01-1.08-1.82c0.66-1.17,1.32-2.86,1.32-4.93"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 38.9,
    cy: 14.98,
    r: 11.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 38.9,
    cy: 14.98,
    r: 11.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.37,17.28c-0.02-0.24-0.1-0.56-0.24-0.97c-0.14-0.41-0.34-0.76-0.6-1.05c-0.26-0.29-0.66-0.59-1.17-0.91 c-0.52-0.32-1.15-0.57-1.89-0.77l-0.6-0.15V9.89c0.28,0.08,0.52,0.24,0.74,0.49c0.32,0.37,0.48,0.82,0.49,1.34h2.8 c-0.08-1.29-0.52-2.28-1.32-2.96c-0.72-0.61-1.62-1-2.71-1.19V6h-0.41H38.3h-0.39v1.56c-1.12,0.14-2.08,0.53-2.87,1.18 c-0.88,0.72-1.32,1.72-1.32,3c0,0.63,0.11,1.18,0.32,1.64c0.21,0.46,0.52,0.84,0.94,1.13c0.41,0.29,0.82,0.52,1.22,0.69 c0.4,0.17,0.89,0.33,1.47,0.47c0.09,0.02,0.17,0.04,0.24,0.06v4.14c-0.46-0.15-0.84-0.4-1.15-0.76c-0.39-0.45-0.59-1.04-0.57-1.75 h-2.8c0.28,2.92,1.79,4.54,4.53,4.88v1.72h0.39h1.17h0.41v-1.72c0.59-0.07,1.13-0.2,1.62-0.38c0.6-0.23,1.07-0.5,1.42-0.81 c0.35-0.31,0.64-0.65,0.88-1.03c0.24-0.38,0.4-0.72,0.48-1.03c0.09-0.31,0.13-0.59,0.13-0.84C44.4,17.81,44.39,17.51,44.37,17.28z  M36.93,12.48c-0.27-0.24-0.4-0.57-0.4-1.01c0-0.53,0.17-0.93,0.52-1.21c0.25-0.2,0.54-0.33,0.87-0.39v3.08 C37.47,12.82,37.14,12.66,36.93,12.48z M40.96,19.41c-0.32,0.25-0.68,0.42-1.08,0.51v-3.61c0.58,0.18,1.01,0.38,1.26,0.59 c0.31,0.26,0.46,0.65,0.46,1.15C41.6,18.62,41.39,19.08,40.96,19.41z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneral2);
export default __webpack_public_path__ + "static/media/General2.7183b167c2ff9f1fdd16cdaae55248d4.svg";
export { ForwardRef as ReactComponent };